import { cn } from 'noddi-ui-common';
import { NoddiCircularLoader } from './NoddiCircularLoader';

export const LoadingScreen = ({ loadingText, className }: { loadingText?: string; className?: string }) => (
  <div className={cn('flex min-h-[60vh] justify-center', className)}>
    <NoddiCircularLoader loadingText={loadingText} />
  </div>
);
